// modules
import * as R from 'ramda'
import {
  WAPP_COMMUNICATE_CORE_EDIT_USER_PROFILE,
  WAPP_COMMUNICATE_CORE_GET_USER_AUTH_TOKEN,
  WAPP_COMMUNICATE_CORE_GET_USER_INFO,
  WAPP_COMMUNICATE_CORE_GET_USER_PROFILE,
  WAPP_COMMUNICATE_CORE_GET_USERS_BY_ID,
  WAPP_COMMUNICATE_CORE_GET_USERS_BY_USERNAME,
  WAPP_COMMUNICATE_CORE_USERS_OPEN_PROFILE,
  wappCommunicateCoreEditUserProfile,
  wappCommunicateCoreGetUserAuthToken,
  wappCommunicateCoreGetUserInfo,
  wappCommunicateCoreGetUserProfile,
  wappCommunicateCoreGetUsersByUsername,
} from '@weblite/wapp-communication-action/core'
import { getClientUser } from '$logic/client-user'
import { getAuthToken } from '$logic/auth'
import { sendOldActionToWapp } from '$logic/wapp-communication/wapp-communication.publish'
import { wappSub } from '$func/subscription'
import { getUser, getUserByUsername } from '$logic/users'
import { openUserProfile } from '$logic/router'
import { getProfile } from '$logic/profile'

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_GET_USER_INFO,
  ({ meta }) => {
    const clientUser = getClientUser()

    sendOldActionToWapp(
      wappCommunicateCoreGetUserInfo({
        ...R.pick(['id', 'phone', 'username', 'firstname', 'lastname', 'bio'])(
          clientUser,
        ),
        profileImage: clientUser.image,
      }),
      meta,
    )
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_GET_USER_PROFILE,
  async ({ meta, payload: { section } }) => {
    const profile = getProfile()?.school || {}
    sendOldActionToWapp(wappCommunicateCoreGetUserProfile({ profile }), meta)
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_EDIT_USER_PROFILE,
  async ({ meta, payload: { section } }) => {
    const profile = getProfile()?.school || {}
    sendOldActionToWapp(wappCommunicateCoreEditUserProfile({ profile }), meta)
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_GET_USER_AUTH_TOKEN,
  async ({ meta }) => {
    const authToken = await getAuthToken()
    sendOldActionToWapp(wappCommunicateCoreGetUserAuthToken(authToken), meta)
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_GET_USERS_BY_USERNAME,
  async ({ meta, payload: { usernames } }) => {
    const users = await Promise.all(
      (usernames as string[]).map(username => getUserByUsername(username)),
    )

    const usersInfo = users
      .filter(Boolean)
      .reduce((acc, user) => ({ ...acc, [user!.username!]: user }), {})

    sendOldActionToWapp(
      wappCommunicateCoreGetUsersByUsername({ usersInfo }),
      meta,
    )
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_GET_USERS_BY_ID,
  async ({ meta, payload: { ids } }) => {
    const users = await Promise.all((ids as string[]).map(id => getUser(id)))

    const usersInfo = users.filter(Boolean).reduce(
      (acc, user) => ({
        ...acc,
        [user.id]: {
          ...user,
          lastname: user.lastname || '',
          profileImage: user.image,
        },
      }),
      {},
    )

    sendOldActionToWapp(
      wappCommunicateCoreGetUsersByUsername({ usersInfo }),
      meta,
    )
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_USERS_OPEN_PROFILE,
  async ({ meta: { mode }, payload: userId }) => {
    const user = await getUser(userId)
    if (user?.id) openUserProfile(userId)
  },
  true,
)
